<template>
    <div v-if="!embedded" class="titulo">
        <div class="margem container">
            <h2>Logs de Projeto</h2>
        </div>
    </div>

    <div class="margem" :class="{ 'logs-embutidos': embedded }">
        <div class="bloco margem" :class="{ 'logs-embutidos__bloco': embedded }">
            <h3 v-if="embedded">Histórico do projeto</h3>
            <div class="filtros-barra alinha-v">
                <button v-if="!embedded" class="toggle-estrategicos acao-secundaria"
                    :class="{ 'toggle-estrategicos--ativo': somenteProjetosEstrategicos }"
                    :aria-pressed="somenteProjetosEstrategicos"
                    :title="somenteProjetosEstrategicos ? 'Exibindo somente projetos estratégicos' : 'Exibindo todos os projetos'"
                    @click="alternarEstrategicos">
                    <i class="bi" :class="somenteProjetosEstrategicos ? 'bi-funnel-fill' : 'bi-funnel'"
                        aria-hidden="true"></i>
                    Somente projetos estratégicos
                </button>
            </div>

            <div v-if="loading" class="loading">
                <div></div>
            </div>

            <div v-else class="tabela-scroll">
                <table class="tabela tabela-logs">
                    <thead>
                        <tr>
                            <th>
                                <div class="th-cabecalho esquerda">
                                    <span class="th-sort" @click="ordenar('projeto_nome')">
                                        Projeto
                                        <i v-if="sortKey === 'projeto_nome'" class="bi"
                                            :class="sortOrder === 'desc' ? 'bi-caret-down-fill' : 'bi-caret-up-fill'"></i>
                                    </span>
                                    <v-menu :close-on-content-click="false">
                                        <template v-slot:activator="{ props }">
                                            <span class="mdi mdi-filter-variant fonte-maior icone"
                                                :class="{ ativo: !!filtros.projeto_busca }" v-bind="props"></span>
                                        </template>
                                        <v-list>
                                            <v-list-item>
                                                <input type="text" v-model="filtros.projeto_busca"
                                                    placeholder="Nome ou código" @keyup.enter="carregar">
                                                <div class="alinha-centro acoes-filtro">
                                                    <span class="chip bg-sucesso" @click="carregar">Filtrar</span>
                                                </div>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </div>
                            </th>
                            <th>
                                <div class="th-cabecalho">
                                    <span class="th-sort" @click="ordenar('origem')">
                                        Tipo
                                        <i v-if="sortKey === 'origem'" class="bi"
                                            :class="sortOrder === 'desc' ? 'bi-caret-down-fill' : 'bi-caret-up-fill'"></i>
                                    </span>
                                    <v-menu :close-on-content-click="false">
                                        <template v-slot:activator="{ props }">
                                            <span class="mdi mdi-filter-variant fonte-maior icone"
                                                :class="{ ativo: !filtroTiposAtivo }" v-bind="props"></span>
                                        </template>
                                        <v-list>
                                            <v-list-item>
                                                <div class="opcoes-filtro">
                                                    <div class="alinha-v" v-for="t in tiposDisponiveis" :key="t.value">
                                                        <input type="checkbox" :id="'tipo-' + t.value"
                                                            v-model="filtrosTipos" :value="t.value">
                                                        <label :for="'tipo-' + t.value">{{ t.label }}</label>
                                                    </div>
                                                </div>
                                                <div class="alinha-centro acoes-filtro">
                                                    <span class="chip bg-sucesso" @click="carregar">Filtrar</span>
                                                </div>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </div>
                            </th>
                            <th>
                                <div class="th-cabecalho">
                                    <span class="th-sort" @click="ordenar('campo')">
                                        Campo
                                        <i v-if="sortKey === 'campo'" class="bi"
                                            :class="sortOrder === 'desc' ? 'bi-caret-down-fill' : 'bi-caret-up-fill'"></i>
                                    </span>
                                    <v-menu :close-on-content-click="false">
                                        <template v-slot:activator="{ props }">
                                            <span class="mdi mdi-filter-variant fonte-maior icone"
                                                :class="{ ativo: !!filtros.campo }" v-bind="props"></span>
                                        </template>
                                        <v-list>
                                            <v-list-item>
                                                <input type="text" v-model="filtros.campo" placeholder="Campo…"
                                                    @keyup.enter="carregar">
                                                <div class="alinha-centro acoes-filtro">
                                                    <span class="chip bg-sucesso" @click="carregar">Filtrar</span>
                                                </div>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </div>
                            </th>
                            <th>
                                <div class="th-cabecalho">
                                    <span class="th-sort" @click="ordenar('valor_antigo')">
                                        Valor anterior
                                        <i v-if="sortKey === 'valor_antigo'" class="bi"
                                            :class="sortOrder === 'desc' ? 'bi-caret-down-fill' : 'bi-caret-up-fill'"></i>
                                    </span>
                                    <v-menu :close-on-content-click="false">
                                        <template v-slot:activator="{ props }">
                                            <span class="mdi mdi-filter-variant fonte-maior icone"
                                                :class="{ ativo: !!filtros.valor_antigo }" v-bind="props"></span>
                                        </template>
                                        <v-list>
                                            <v-list-item>
                                                <input type="text" v-model="filtros.valor_antigo" placeholder="Conteúdo…"
                                                    @keyup.enter="carregar">
                                                <div class="alinha-centro acoes-filtro">
                                                    <span class="chip bg-sucesso" @click="carregar">Filtrar</span>
                                                </div>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </div>
                            </th>
                            <th>
                                <div class="th-cabecalho">
                                    <span class="th-sort" @click="ordenar('valor_novo')">
                                        Valor novo
                                        <i v-if="sortKey === 'valor_novo'" class="bi"
                                            :class="sortOrder === 'desc' ? 'bi-caret-down-fill' : 'bi-caret-up-fill'"></i>
                                    </span>
                                    <v-menu :close-on-content-click="false">
                                        <template v-slot:activator="{ props }">
                                            <span class="mdi mdi-filter-variant fonte-maior icone"
                                                :class="{ ativo: !!filtros.valor_novo }" v-bind="props"></span>
                                        </template>
                                        <v-list>
                                            <v-list-item>
                                                <input type="text" v-model="filtros.valor_novo" placeholder="Conteúdo…"
                                                    @keyup.enter="carregar">
                                                <div class="alinha-centro acoes-filtro">
                                                    <span class="chip bg-sucesso" @click="carregar">Filtrar</span>
                                                </div>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </div>
                            </th>
                            <th>
                                <div class="th-cabecalho">
                                    <span class="th-sort" @click="ordenar('usuario_nome')">
                                        Alterado por
                                        <i v-if="sortKey === 'usuario_nome'" class="bi"
                                            :class="sortOrder === 'desc' ? 'bi-caret-down-fill' : 'bi-caret-up-fill'"></i>
                                    </span>
                                    <v-menu :close-on-content-click="false">
                                        <template v-slot:activator="{ props }">
                                            <span class="mdi mdi-filter-variant fonte-maior icone"
                                                :class="{ ativo: !!filtros.usuario_nome }" v-bind="props"></span>
                                        </template>
                                        <v-list>
                                            <v-list-item>
                                                <input type="text" v-model="filtros.usuario_nome" placeholder="Nome…"
                                                    @keyup.enter="carregar">
                                                <div class="alinha-centro acoes-filtro">
                                                    <span class="chip bg-sucesso" @click="carregar">Filtrar</span>
                                                </div>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </div>
                            </th>
                            <th>
                                <div class="th-cabecalho">
                                    <span class="th-sort" @click="ordenar('funcao_label')">
                                        Função
                                        <i v-if="sortKey === 'funcao_label'" class="bi"
                                            :class="sortOrder === 'desc' ? 'bi-caret-down-fill' : 'bi-caret-up-fill'"></i>
                                    </span>
                                    <v-menu :close-on-content-click="false">
                                        <template v-slot:activator="{ props }">
                                            <span class="mdi mdi-filter-variant fonte-maior icone"
                                                :class="{ ativo: !filtroFuncoesAtivo }" v-bind="props"></span>
                                        </template>
                                        <v-list>
                                            <v-list-item>
                                                <div class="opcoes-filtro">
                                                    <div class="alinha-v" v-for="f in funcoesDisponiveis" :key="f.value">
                                                        <input type="checkbox" :id="'funcao-' + f.value"
                                                            v-model="filtrosFuncoes" :value="f.value">
                                                        <label :for="'funcao-' + f.value">{{ f.label }}</label>
                                                    </div>
                                                </div>
                                                <div class="alinha-centro acoes-filtro">
                                                    <span class="chip bg-sucesso" @click="carregar">Filtrar</span>
                                                </div>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </div>
                            </th>
                            <th>
                                <div class="th-cabecalho">
                                    <span class="th-sort" @click="ordenar('quando')">
                                        Quando
                                        <i v-if="sortKey === 'quando'" class="bi"
                                            :class="sortOrder === 'desc' ? 'bi-caret-down-fill' : 'bi-caret-up-fill'"></i>
                                    </span>
                                    <v-menu :close-on-content-click="false">
                                        <template v-slot:activator="{ props }">
                                            <span class="mdi mdi-filter-variant fonte-maior icone"
                                                :class="{ ativo: !!(filtros.dt_inicio || filtros.dt_fim) }"
                                                v-bind="props"></span>
                                        </template>
                                        <v-list>
                                            <v-list-item>
                                                <v-list-item-title>Período</v-list-item-title>
                                                <div class="alinha-v periodo-filtro">
                                                    <input type="date" v-model="filtros.dt_inicio"> até
                                                    <input type="date" v-model="filtros.dt_fim">
                                                </div>
                                                <div class="alinha-centro acoes-filtro">
                                                    <span class="chip bg-sucesso" @click="carregar">Filtrar</span>
                                                </div>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="registros.length === 0">
                            <td colspan="8" class="alinha-centro">
                                <span class="chip bg-cinza">Nenhum registro encontrado</span>
                            </td>
                        </tr>
                        <tr v-for="item in registros" :key="item.id"
                            class="linha-log"
                            :class="{ 'linha-log--clicavel': item.projeto_id && !embedded }"
                            :role="item.projeto_id && !embedded ? 'button' : null"
                            :tabindex="item.projeto_id && !embedded ? 0 : -1"
                            :title="tituloLinha(item)"
                            @click="abrirRegistro(item)"
                            @keydown.enter="abrirRegistro(item)">
                            <td style="text-align: left !important">
                                <span v-if="item.pcm_codigo">{{ item.pcm_codigo }} · </span>
                                {{ item.projeto_nome || '—' }}
                                <span v-if="item.entrega_nome" class="subtexto"> / {{ item.entrega_nome }}</span>
                                <span v-if="item.tarefa_nome" class="subtexto"> / {{ item.tarefa_nome }}</span>
                            </td>
                            <td>
                                <span class="chip bg-cinza">
                                    {{ labelOrigem(item.origem) }}
                                </span>
                            </td>
                            <td>{{ item.campo }}</td>
                            <td class="celula-texto" :title="item.valor_antigo || ''">{{ resumir(item.valor_antigo) }}</td>
                            <td class="celula-texto" :title="item.valor_novo || ''">{{ resumir(item.valor_novo) }}</td>
                            <td>{{ item.usuario_nome || '—' }}</td>
                            <td>{{ item.funcao_label || '—' }}</td>
                            <td>{{ formatarQuando(item.quando) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <p v-if="!loading && total > 0" class="rodape-total">{{ total }} registro(s)</p>
        </div>
    </div>
</template>

<script>
import { listarLogsProjeto } from '@/services/serviceLogsProjeto'
import { useOrdenacaoColuna } from '@/composables/useOrdenacaoColuna'
import { useApiError } from '@/composables/useApiError'
import { formatarDataHoraBr } from '@/utils/date'

const TIPOS_PADRAO = ['projeto', 'entrega', 'tarefa']
const FUNCOES_PADRAO = ['auditor', 'gerente', 'assessor', 'coordenador']

export default {
    name: 'LogsProjeto',

    props: {
        projetoId: {
            type: [Number, String],
            default: null,
        },
        embedded: {
            type: Boolean,
            default: false,
        },
    },

    setup() {
        const { sortKey, sortOrder, toggleOrdenacao } = useOrdenacaoColuna('quando', 'desc')
        const { handleError } = useApiError()
        return { sortKey, sortOrder, toggleOrdenacao, handleApiError: handleError }
    },

    data() {
        return {
            loading: true,
            registros: [],
            total: 0,
            somenteProjetosEstrategicos: !this.embedded,
            filtros: {
                projeto_busca: '',
                campo: '',
                valor_antigo: '',
                valor_novo: '',
                usuario_nome: '',
                dt_inicio: '',
                dt_fim: '',
            },
            filtrosTipos: [...TIPOS_PADRAO],
            filtrosFuncoes: [...FUNCOES_PADRAO],
            tiposDisponiveis: [
                { value: 'projeto', label: 'Projeto' },
                { value: 'entrega', label: 'Pacote de trabalho' },
                { value: 'tarefa', label: 'Tarefa' },
            ],
            funcoesDisponiveis: [
                { value: 'auditor', label: 'Auditor' },
                { value: 'gerente', label: 'Gerente' },
                { value: 'assessor', label: 'Assessor do Gerente' },
                { value: 'coordenador', label: 'Coordenador' },
            ],
        }
    },

    computed: {
        filtroTiposAtivo() {
            return TIPOS_PADRAO.every((t) => this.filtrosTipos.includes(t))
        },
        filtroFuncoesAtivo() {
            return FUNCOES_PADRAO.every((f) => this.filtrosFuncoes.includes(f))
        },
    },

    mounted() {
        this.carregar()
    },

    methods: {
        async carregar() {
            this.loading = true
            try {
                const payload = {
                    ...this.filtros,
                    sort_key: this.mapSortKey(this.sortKey),
                    sort_order: this.sortOrder,
                }

                if (this.projetoId) {
                    payload.projeto_id = Number(this.projetoId)
                }
                if (!this.filtroTiposAtivo) {
                    payload.tipos = [...this.filtrosTipos]
                }
                if (!this.filtroFuncoesAtivo && this.filtrosFuncoes.length > 0) {
                    payload.funcoes = [...this.filtrosFuncoes]
                }
                if (this.somenteProjetosEstrategicos) {
                    payload.somente_estrategicos = true
                }

                Object.keys(payload).forEach((k) => {
                    if (payload[k] === '' || payload[k] == null) delete payload[k]
                })

                const data = await listarLogsProjeto(payload)
                this.registros = data.registros || []
                this.total = data.total ?? this.registros.length
            } catch (error) {
                this.handleApiError(error)
            } finally {
                this.loading = false
            }
        },

        mapSortKey(key) {
            if (key === 'funcao_label') return 'funcao'
            return key
        },

        ordenar(key) {
            this.toggleOrdenacao(key)
            this.carregar()
        },

        alternarEstrategicos() {
            this.somenteProjetosEstrategicos = !this.somenteProjetosEstrategicos
            this.carregar()
        },

        formatarQuando(iso) {
            if (!iso) return '—'
            return formatarDataHoraBr(iso)
        },

        resumir(valor) {
            if (valor == null || valor === '') return '—'
            const s = String(valor)
            return s.length > 80 ? `${s.slice(0, 80)}…` : s
        },

        labelOrigem(origem) {
            if (origem === 'entrega') return 'Pacote de trabalho'
            if (origem === 'tarefa') return 'Tarefa'
            if (origem === 'pcm') return 'PCM'
            if (origem === 'projeto') return 'Projeto'
            return origem || '—'
        },

        tituloLinha(item) {
            if (!item.projeto_id || this.embedded) return ''
            if (item.tarefa_id) return 'Abrir tarefa no plano do projeto'
            return item.entrega_id
                ? 'Abrir projeto na aba de pacotes de trabalho'
                : 'Abrir projeto'
        },

        abrirRegistro(item) {
            if (!item?.projeto_id || this.embedded) return
            const query = { aba: 3 }
            if (item.entrega_id) {
                query.entrega_id = item.entrega_id
            }
            if (item.tarefa_id) {
                query.destaque_tarefa_id = item.tarefa_id
            }
            this.$router.push({
                name: 'projetoView',
                params: { idProjeto: item.projeto_id },
                query,
            })
        },
    },
}
</script>

<style scoped>
.logs-embutidos {
    margin: 0;
}

.logs-embutidos__bloco {
    margin: 0;
    box-shadow: none;
}

.filtros-barra {
    gap: 1rem;
    flex-wrap: wrap;
    margin-bottom: 1rem;
}

.toggle-estrategicos {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.45rem 0.85rem !important;
    border-radius: 999px !important;
    font-size: 0.85rem;
    font-weight: 600;
    white-space: nowrap;
}

.toggle-estrategicos--ativo {
    color: var(--cor-primaria-forte, #008a88) !important;
    border-color: var(--cor-primaria, #00b6b3) !important;
    background: var(--cor-primaria-fraca, rgba(0, 182, 179, 0.15)) !important;
}

.tabela-logs th {
    white-space: nowrap;
}

.th-cabecalho {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
}

.th-sort {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    font-weight: 600;
}

.icone.ativo {
    border-bottom: 2px solid var(--cor-ok);
}

.opcoes-filtro {
    display: flex;
    flex-flow: column;
    gap: 0.5rem;
    min-width: 10rem;
}

.opcoes-filtro label {
    margin-bottom: 0;
}

.acoes-filtro {
    padding-block: 0.5rem;
}

.periodo-filtro {
    gap: 0.5rem;
    margin-top: 0.35rem;
}

.celula-texto {
    max-width: 14rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.subtexto {
    opacity: 0.75;
    font-size: 0.85em;
}

.linha-log--clicavel {
    cursor: pointer;
}

.linha-log--clicavel:hover {
    background: var(--cor-primaria-fraca, rgba(0, 182, 179, 0.08));
}

.linha-log--clicavel:focus-visible {
    outline: 2px solid var(--cor-primaria, #00b6b3);
    outline-offset: -2px;
}

.rodape-total {
    margin: 0.75rem 0 0;
    font-size: 0.88rem;
    opacity: 0.75;
    text-align: right;
}
</style>
